"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../actionTypes/translations");
exports.initialState = {
    currentLanguage: 'fi',
    translations: {
        status: 'STANDBY'
    },
    translationsFile: {
        file: [],
        status: 'STANDBY'
    },
    excelInfo: {
        status: 'STANDBY'
    }
};
const translationsLens = monocle.Lens.fromProp('translations');
const translationsFileLens = monocle.Lens.fromProp('translationsFile');
const currentLanguage = monocle.Lens.fromProp('currentLanguage');
const excelInfoStateLens = monocle.Lens.fromProp('excelInfo');
const statusLens = monocle.Lens.fromProp('status');
const excelInfoStatusLens = monocle.Lens.fromProp('status');
const translationsFileStatusLens = monocle.Lens.fromProp('status');
const errorLens = new monocle.Setter((set) => (state) => {
    if (state.status === 'FAILURE') {
        return Object.assign(Object.assign({}, state), { reason: set(state.reason) });
    }
    return state;
});
const fileLens = new monocle.Setter((set) => (state) => {
    if (state.status === 'UPLOADED' ||
        state.status === 'SET' ||
        state.status === 'UPLOADING') {
        return Object.assign(Object.assign({}, state), { file: set(state.file) });
    }
    return state;
});
const excelInfoLens = new monocle.Setter((set) => (state) => {
    if (state.status === 'FETCHED') {
        return Object.assign(Object.assign({}, state), { data: set(state.data) });
    }
    return state;
});
const translations = (state = exports.initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_REQUEST: {
            return fp.function.compose(translationsLens.modify(statusLens.set('FETCHING')), currentLanguage.set(action.payload.language))(state);
        }
        case ActionTypes.FETCH_SUCCESS: {
            return translationsLens.modify(statusLens.set('FETCHED'))(state);
        }
        case ActionTypes.FETCH_FAILED: {
            return translationsLens.modify(fp.function.compose(errorLens.set(action.payload.error), statusLens.set('FAILURE')))(state);
        }
        case ActionTypes.UPLOAD_TRANSLATIONS_FILE: {
            return translationsFileLens.modify(fp.function.compose(fileLens.set(action.payload.file), translationsFileStatusLens.set('UPLOADING')))(state);
        }
        case ActionTypes.SET_TRANSLATIONS_FILE: {
            return translationsFileLens.modify(fp.function.compose(fileLens.set(action.payload.file), translationsFileStatusLens.set('SET')))(state);
        }
        case ActionTypes.UPLOAD_TRANSLATIONS_FILE_FAILED: {
            return translationsFileLens.modify(translationsFileStatusLens.set('ERROR'))(state);
        }
        case ActionTypes.UPLOAD_TRANSLATIONS_FILE_SUCCESS: {
            return translationsFileLens.modify(fp.function.compose(fileLens.set([]), translationsFileStatusLens.set('UPLOADED')))(state);
        }
        case ActionTypes.SET_STANDBY: {
            return translationsFileLens.modify(translationsFileStatusLens.set('STANDBY'))(state);
        }
        case ActionTypes.FETCH_EXCEL_INFO_REQUEST: {
            return excelInfoStateLens.modify(excelInfoStatusLens.set('FETCHING'))(state);
        }
        case ActionTypes.FETCH_EXCEL_INFO_SUCCESS: {
            return excelInfoStateLens.modify(fp.function.compose(excelInfoLens.set(action.payload.info), excelInfoStatusLens.set('FETCHED')))(state);
        }
        case ActionTypes.FETCH_EXCEL_INFO_FAILED: {
            return excelInfoStateLens.modify(excelInfoStatusLens.set('FAILURE'))(state);
        }
        case ActionTypes.CLEAR_SYSTEM: {
            return fp.function.compose(excelInfoStateLens.set({ status: 'STANDBY' }), translationsFileLens.set({ status: 'STANDBY', file: [] }))(state);
        }
        default:
            return state;
    }
};
exports.translations = translations;
//# sourceMappingURL=translations.js.map